<template>
  <div id="calendar" class="calendar_bar">

    <div class="calendar">
      <div class="top_bar">
        <h2>活动日历</h2>
        <div class="change_mon">
          <div class="prev_mon iconfont icon-xiangzuojiantou" @click="prevButton()"></div>
          <div class="year_mon">2023/4</div>
          <div class="next_mon iconfont icon-xiangyoujiantou" @click="nextButton()"></div>
        </div>
      </div>

      <div class="week">
        <div class="week_item">日</div>
        <div class="week_item">一</div>
        <div class="week_item">二</div>
        <div class="week_item">三</div>
        <div class="week_item">四</div>
        <div class="week_item">五</div>
        <div class="week_item">六</div>
      </div>

      <div id="swiper" class="campus_wrap">
        <div class="swiper-container dateSwiper" ref="dateSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              1
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>


<script>

// 基于 Swiper 版本 4/5
import Swiper from 'swiper'
import "swiper/css/swiper.min.css"

export default {
  name: 'dy-calendar',
  props: {
    // curTime: {
    //   type: String,
    //   default: null
    // }
    dataList:{
      type:Array,
      default:()=>[]
    }
  },
  data() {
    return {
      curTime: new Date(),
      curYear: new Date().getFullYear(),
      curMonth: new Date().getMonth() + 1,
      curDate: new Date().getDate(),
      // 打点数据
      // dataList: [
      //   {
      //     date: '2023/9/15',
      //     info: '活动一'
      //   },
      // ]
    }
  },

  created() {
    let _this = this;
    window.getDayInfo = _this.getDayInfo;
  },
  mounted() {

    new Swiper(".dateSwiper", {
      loop: true,
      allowTouchMove: false,
      noSwiping: true,
    });

    this.init()

    // console.log(this.swiper)

  },
  computed: {
    // curYear() {
    //   return this.curTime.getFullYear();
    // },
    // curMonth() {
    //   return this.curTime.getMonth() + 1;
    // },
    // curDate() {
    //   return this.curTime.getDate();
    // },
    nowDate() {
      return `${new Date().getFullYear()}/${new Date().getMonth() + 1}/${this.curTime.getDate().length !== 2 ? this.curTime.getDate() : '0' + this.curTime.getDate()}`
    },
    // 获取单签 swiper 实例
    swiper() {
      return this.$refs.dateSwiper.dom7ElementDataStorage.swiper;
      // return this.$refs.sec1Swiper.$swiper;
    },
  },
  methods: {
    // 判断平年还是闰年
    isLeapYear(year) {
      return (year % 400 === 0) || ((year % 4 === 0) && (year % 100 !== 0))
    },
    // 计算每月天数和日期是周几
    getWeekInMonth(curYear, curMonth) {
      // 判断今年是平年还是闰年，并确定今年的每个月有多少天
      let daysInMonth = [31, this.isLeapYear(curYear) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      // 确定本月第一天是周几
      let firstDayInMonth = new Date(`${curMonth}/1/${curYear}`).getDay()

      let days = []
      for (let i = 0; i < firstDayInMonth; i++) {
        days.push(null);
      }
      for (let i = 1; i <= daysInMonth[curMonth - 1]; i++) {
        if (i.toString().length == 1) {
          days.push('0' + i.toString());
        } else {
          days.push(i.toString());
        }
      }
      return days;
    },
    // 按照星期渲染月份生成的字符串
    render(curYear, curMonth) {
      let days = this.getWeekInMonth(curYear, curMonth)
      let days_str = ""
      days.forEach((v) => {
        if (v == null) {
          days_str += `<div class="date_item"></div>`
        } else {
          days_str += `<div class="date_item"  data-date='${curYear}/${curMonth}/${v}' onclick='getDayInfo(event)'><span>${v}</span></div>`
        }
      })
      return days_str
    },
    // 将字符串渲染到DOM上
    init() {
      // console.log(curYear)
      // console.log(curMonth)
      let curYear = this.curYear
      let curMonth = this.curMonth
      let nowDate = this.nowDate

      // 渲染当前年月
      document.querySelector('.year_mon').innerHTML = `${curYear}/${curMonth}`;

      let calendar = document.getElementById('calendar')

      // 渲染月份日期
      calendar.querySelector('.swiper-slide-prev').innerHTML = this.render(curYear, curMonth - 1);
      calendar.querySelector('.swiper-slide-active').innerHTML = this.render(curYear, curMonth);
      calendar.querySelector('.swiper-slide-next').innerHTML = this.render(curYear, curMonth + 1);

      // 高亮当前日期
      var element = calendar.querySelector('.swiper-slide-active');
      var arrItem = element.querySelectorAll('.date_item')

      // 生成当月日期信息数组
      var arrDayInfo = []
      for (var i = 0; i < arrItem.length; i++) {
        if (arrItem[i].getAttribute('data-date') == nowDate) {
          arrItem[i].classList.add("cur_day")
        }
        arrDayInfo.push({
          index: i,
          dayInfo: arrItem[i].getAttribute('data-date')
        })
      }

      // console.log(arrDayInfo)
      // 渲染绑定的数据
      if (this.dataList.length > 0) {

        let tempArr = this.dataList.filter(item => {
          if (item.date.includes(`${curYear}/${curMonth}`)) {
            return item
          }
        })
        // console.log(tempArr)
        for (let i = 0; i < tempArr.length; i++) {
          for (let j = 0; j < arrDayInfo.length; j++) {
            if (tempArr[i].date === arrDayInfo[j].dayInfo) {
              arrItem[arrDayInfo[j].index].classList.add("hasInfo")
              arrItem[arrDayInfo[j].index].setAttribute("data-info", tempArr[i].info)
              arrItem[arrDayInfo[j].index].setAttribute("data-id", tempArr[i].id)
              // indices.push(arrDayInfo[j].index);
            }
          }
        }
      }
    },

    prevButton() {
      this.swiper.slidePrev();
      this.curMonth--
      if (this.curMonth < 1) {
        this.curYear -= 1
        this.curMonth = 12
      }
      document.querySelector('.year_mon').innerHTML = `${this.curYear}/${this.curMonth}`;
      this.init()
    },

    nextButton() {
      this.swiper.slideNext();
      this.curMonth++
      if (this.curMonth > 12) {
        this.curYear += 1
        this.curMonth = 1
      }
      document.querySelector('.year_mon').innerHTML = `${this.curYear}/${this.curMonth}`;
      this.init()
    },

    getDayInfo(event) {
      // console.log(event.currentTarget.getAttribute("data-date"))
      // console.log(event.currentTarget.getAttribute("data-info") ? event.currentTarget.getAttribute("data-info") : null)
      this.$emit("activity-trigger", event.currentTarget.getAttribute("data-id") || null)
    }

  }
}
</script>


<style scoped>
.calendar_bar {
  width: 100%;
  background-color: #fff;
  margin-bottom: 30px;
  border-radius: 10px 10px 0 0;
}

.main-wrap {
  width: 1200px;
  margin: 0 auto;

}

.con_bar {
  width: 1200px;
  margin: 30px auto 0;
}

.calendar {
  width: 481px;
  height: 371px;
  border-radius: 10px 10px;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.calendar .top_bar {
  height: 56px;
  display: flex;
  padding: 0 25px;
  justify-content: space-between;
  align-items: center;
  background-color: #eaf0fe;
  border-radius: 10px 10px 0 0;
}

.calendar .top_bar h2 {
  font-size: 20px;
  color: #0164eb;
}

.calendar .top_bar .change_mon {
  display: flex;
  font-size: 18px;
  color: #b7b9bb;
}

.calendar .top_bar .change_mon .year_mon {
  margin: 0 10px;
}

.calendar .top_bar .change_mon .prev_mon,
.calendar .top_bar .change_mon .next_mon {
  cursor: pointer;
  font-size: 18px;
}

.week {
  display: flex;
  background-color: #fcfcfe;
  font-size: 16px;
  color: #bcb8b8;
  align-items: center;
  padding: 11px 0%;
}

.week .week_item {
  width: 14%;
  display: flex;
  justify-content: center;
}

.calendar>>>.swiper {
  width: 100%;
  height: 270px;
  border-radius: 10px;
}

.calendar>>>.swiper-slide {
  height: 260px;
  background-color: #fcfcfe;
  padding-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  height: 268px;
}

.calendar>>>.swiper-slide .date_item {
  width: 14%;
  color: #333;
  font-size: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.calendar>>>.swiper-slide .date_item span {
  position: relative;
  border-radius: 50%;
  padding: 6px;
  cursor: pointer;
}

.calendar>>>.swiper-slide .cur_day span {
  background-color: #fe6d00;
  color: #fff;
  width: 37px;
    text-align: center;
}

.calendar>>>.swiper-slide .hasInfo span::before {
  content: "";
  display: block;
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #fd0100;
  right: -1px;
  top: 0px;
}
</style>
